import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClientCustom } from './http-client';
import { ConvertObjectToDictionary, SERVICE_URL } from '../constants/global';
import { ReturnStatusHtml } from '../models/returnStatus';
import { MasterService } from './master.service';
import { ErrorTreatmentFunctions } from '../modules/treatments.module';
// import { Dropdown } from '../models/dropdown';
import { DatatableParameters } from '../models/datatable-parameters';
import { DropdownEditable } from '../models/dropdown-editable';
import { AuthenticationService } from './authentication.service';
import { Dropdown } from '../models/dropdown';

@Injectable()
export class DropDownService {
  private _controller: string = 'DropDown';

  datatableParameters: DatatableParameters = new DatatableParameters([null, null, null, null, null, null], 10, [[2, 'asc']], 0);

  showCompanyGroup: boolean;
  showCompanyGroupColumn: boolean;
  showRecordDescription: boolean;
  showRecordOrder: boolean;
  showOrderColumn: boolean;
  showRecordParentCode: boolean;

  constructor(private http: HttpClientCustom,
    private _masterService: MasterService,
    private _errorTreat: ErrorTreatmentFunctions,
    private authenticationService: AuthenticationService) { }

  get(id: number, customParents: any): Observable<ReturnStatusHtml> {

    //Dicionário
    let dic = customParents?.map(x => 'customParents['+x.DropDownID+ ']=' + x.Parent)

    return this.http.get(SERVICE_URL + this._controller + '/Get?id=' + id + (dic ? '&' + dic.join("&") : ''))
      .pipe(map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }

  add(model: DropdownEditable): Observable<ReturnStatusHtml> {
    return this.http.put(SERVICE_URL + this._controller + '/Add', { entity: model })
      .pipe(map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }

  update(model: DropdownEditable): Observable<ReturnStatusHtml> {
    return this.http.post(SERVICE_URL + this._controller + '/Update', { entity: model })
      .pipe(map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }

  delete(id: number): Observable<ReturnStatusHtml> {
    return this.http.delete(SERVICE_URL + this._controller + '/Delete?id=' + id)
      .pipe(map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }

  addDropdownData(model: Dropdown): Observable<ReturnStatusHtml> {
    return this.http.put(SERVICE_URL + this._controller + '/AddRecord', { entity: model })
      .pipe(map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }

  updateDropdownData(model: Dropdown): Observable<ReturnStatusHtml> {
    return this.http.post(SERVICE_URL + this._controller + '/UpdateRecord', { entity: model })
      .pipe(map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }

  deleteDropdownData(id: number): Observable<ReturnStatusHtml> {
    return this.http.delete(SERVICE_URL + this._controller + '/DeleteRecord?id=' + id)
      .pipe(map((response: any) => this._masterService.convertToReturnStatusHtml(response)));
  }

  /**
  * Download de Excel de cada lista de valores (dropdownsdata)
  * @param  {number} id
  * @returns Observable
  */
  downloadExcelDropdownsDataList(id: number, customParents: any): Observable<any> {
    //Dicionário
    let dic = customParents?.map(x => 'customParents['+x.DropDownID+ ']=' + x.Parent)
    return this.http.getFile(SERVICE_URL + this._controller + '/DownloadExcelDropdownsDataList?id=' + id + (dic ? '&' + dic.join("&") : ''));
  }

  downloadExcelList(params: any): Observable<any> {
    return this.http.postFile(SERVICE_URL + this._controller + '/DownloadExcelList', { parameters: params });
  }

  // getAll(type: string): Observable<Dropdown[]> {
  //   return this.http.get(SERVICE_URL + this._controller + '/GetAll?type=' + type)
  //     .pipe(map(response => {
  //       try {
  //         let responseReturn = this._masterService.convertToReturnStatusHtml(response);
  //         if (responseReturn.ReturnStatus.Successfull) {
  //           return responseReturn.ReturnStatus.ReturnObject;
  //         } else {
  //           this._errorTreat.treatErrorResponseSendEmpty(responseReturn);
  //         }
  //       } catch (error) {
  //         this._masterService.handleError(error);
  //       }
  //     }));
  // }

  get_showCompanyGroup(defaultValue: boolean): boolean {
    if (typeof this.showCompanyGroup === 'undefined') { // verificar se ainda nao tem valor
      let settingValue = this.authenticationService.getSettingPortal('DropDown', 'ShowCompanyGroup');
      if (settingValue != null) {
        this.showCompanyGroup = settingValue;
      } else {
        this.showCompanyGroup = defaultValue;
      }
    }
    return this.showCompanyGroup;
  }

  get_showCompanyGroupColumn(defaultValue: boolean): boolean {
    if (typeof this.showCompanyGroupColumn === 'undefined') { // verificar se ainda nao tem valor
      let settingValue = this.authenticationService.getSettingPortal('DropDown', 'ShowCompanyGroupColumn');
      if (settingValue != null) {
        this.showCompanyGroupColumn = settingValue;
      } else {
        this.showCompanyGroupColumn = defaultValue;
      }
    }
    return this.showCompanyGroupColumn;
  }

  get_showRecordDescription(defaultValue: boolean): boolean {
    if (typeof this.showRecordDescription === 'undefined') { // verificar se ainda nao tem valor
      let settingValue = this.authenticationService.getSettingPortal('DropDown', 'ShowRecordDescription');
      if (settingValue != null) {
        this.showRecordDescription = settingValue;
      } else {
        this.showRecordDescription = defaultValue;
      }
    }
    return this.showRecordDescription;
  }

  get_showRecordOrder(defaultValue: boolean): boolean {
    if (typeof this.showRecordOrder === 'undefined') { // verificar se ainda nao tem valor
      let settingValue = this.authenticationService.getSettingPortal('DropDown', 'ShowRecordOrder');
      if (settingValue != null) {
        this.showRecordOrder = settingValue;
      } else {
        this.showRecordOrder = defaultValue;
      }
    }
    return this.showRecordOrder;
  }

  get_ShowOrderColumn(defaultValue: boolean): boolean {
    if (typeof this.showOrderColumn === 'undefined') { // verificar se ainda nao tem valor
      let settingValue = this.authenticationService.getSettingPortal('DropDown', 'ShowOrderColumn');
      if (settingValue != null) {
        this.showOrderColumn = settingValue;
      } else {
        this.showOrderColumn = defaultValue;
      }
    }
    return this.showOrderColumn;
  }

  get_showRecordParentCode(defaultValue: boolean): boolean {
    if (typeof this.showRecordParentCode === 'undefined') { // verificar se ainda nao tem valor
      let settingValue = this.authenticationService.getSettingPortal('DropDown', 'ShowRecordParentCode');
      if (settingValue != null) {
        this.showRecordParentCode = settingValue;
      } else {
        this.showRecordParentCode = defaultValue;
      }
    }
    return this.showRecordParentCode;
  }

  private additionalFieldParentCode: any;
  get_additionalFieldParentCode(defaultValue: any): any {
    if (typeof this.additionalFieldParentCode === 'undefined') { // verificar se ainda nao tem valor
      let settingValue = this.authenticationService.getSettingPortal('DropDown', 'AdditionalFieldParentCode');
      if (settingValue != null) {
        this.additionalFieldParentCode = settingValue;
      } else {
        this.additionalFieldParentCode = defaultValue;
      }
    }
    return this.additionalFieldParentCode;
  }

  private showParentDescriptionColumn: any;
  get_showParentDescriptionColumn(defaultValue: any): any {
    if (typeof this.showParentDescriptionColumn === 'undefined') { // verificar se ainda nao tem valor
      let settingValue = this.authenticationService.getSettingPortal('DropDown', 'ShowParentDescriptionColumn');
      if (settingValue != null) {
        this.showParentDescriptionColumn = settingValue;
      } else {
        this.showParentDescriptionColumn = defaultValue;
      }
    }
    return this.showParentDescriptionColumn;
  }

  private hideExportExcelButton: boolean;
  get_hideExportExcelButton(defaultValue: boolean): boolean {
    if (typeof this.hideExportExcelButton === 'undefined') { // verificar se ainda nao tem valor
      let settingValue = this.authenticationService.getSettingPortal('DropDown', 'HideExportExcelButton');
      if (settingValue != null) {
        this.hideExportExcelButton = settingValue;
      } else {
        this.hideExportExcelButton = defaultValue;
      }
    }
    return this.hideExportExcelButton;
  }

  //#region showAllCompaniesCheckbox
  private _showAllCompaniesCheckbox: boolean;

  /** Mostrar/ esconder campo de checkbox se é para todas as empresas ou nao */
  public get showAllCompaniesCheckbox () {
    this._showAllCompaniesCheckbox = this.authenticationService.getBooleanSetting(true, this._showAllCompaniesCheckbox, 'DropDown', 'ShowAllCompaniesCheckbox');
    return this._showAllCompaniesCheckbox;
  }

  //sem cache
  GetDropdownData(type, parentCode: string = null, filterByCompany: boolean = false): Observable<Dropdown[]> {
    return this.http.get(SERVICE_URL + 'common/GetDropdownData?type=' + type + (parentCode ? '&parentCode=' + parentCode : '') + (filterByCompany ? '&filterByCompany='+ filterByCompany: '')).pipe(map(response => {
      try {
        let responseReturn = this._masterService.convertToReturnStatusHtml(response);
        if (responseReturn.ReturnStatus.Successfull) {
          return responseReturn.ReturnStatus.ReturnObject as Dropdown[];
        } else {
          this._errorTreat.treatErrorResponseSendEmpty(responseReturn);
        }
      } catch (error) {
        this._masterService.handleError(error);
      }
    }));
  }

  //#endregion showAllCompaniesCheckbox
}
